import { SVGProps } from 'react';

const IcRegularCustomer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    {...props}
  >
    <path
      d='M4.70488 1.66675H14.4656C15.1545 1.75934 15.8063 2.16823 16.1182 2.80008C16.4122 3.33785 16.3456 3.96748 16.35 4.55562C16.3485 8.43264 16.3485 12.3104 16.35 16.1874C16.3604 16.7859 16.1167 17.3867 15.6685 17.7874C15.3404 18.0978 14.9026 18.2578 14.4648 18.3333H4.70413C4.01451 18.2422 3.36118 17.8341 3.04785 17.2022C2.756 16.6637 2.80563 16.0348 2.80637 15.4445C2.80785 11.5911 2.80785 7.73783 2.80563 3.88452C2.80266 3.40304 2.92637 2.91193 3.21822 2.52304C3.56118 2.03712 4.12414 1.75045 4.70488 1.66675ZM4.69302 3.26748C4.43969 3.35341 4.3508 3.63933 4.36562 3.88303C4.36858 7.78598 4.36858 11.6897 4.36636 15.5926C4.37303 15.8741 4.33599 16.163 4.40636 16.4393C4.49006 16.6956 4.77525 16.7956 5.02339 16.7793C8.08856 16.7741 11.1537 16.78 14.2189 16.7763C14.467 16.7904 14.7226 16.6333 14.7752 16.3822C14.8248 16.0726 14.7937 15.7571 14.7996 15.4452C14.7989 11.5911 14.7974 7.73709 14.8004 3.88303C14.8589 3.50229 14.5308 3.16081 14.1463 3.22081C11.1048 3.22378 8.06338 3.22378 5.02191 3.22081C4.91154 3.22526 4.79821 3.22822 4.69302 3.26748Z'
      fill='#2D6772'
    />
    <use xlinkHref='#stroke0_26501_2269' fill='#2D6772' />
    <mask id='stroke1_26501_2269' fill='white'>
      <use xlinkHref='#stroke0_26501_2269' />
    </mask>
    <path
      d='M17.4874 3.9794C17.6311 3.75051 17.9666 3.68681 18.1918 3.82977C18.3155 3.91866 18.374 4.06606 18.4363 4.1994V6.47642C18.3489 6.61124 18.2622 6.76309 18.1103 6.8342C17.8711 6.93494 17.5563 6.82531 17.4555 6.58013C17.3881 6.40902 17.3992 6.22087 17.394 6.04087C17.4 5.54383 17.3985 5.04754 17.3948 4.55051C17.4015 4.3594 17.3866 4.15125 17.4874 3.9794Z'
      strokeWidth='2.66667'
      stroke='#2D6772'
      mask='url(#stroke1_26501_2269)'
    />
    <path
      d='M9.28175 5.86136C10.0306 5.74358 10.824 6.07395 11.2632 6.69247C11.9114 7.54209 11.7395 8.87912 10.8921 9.53245C10.1336 10.1695 8.92323 10.1384 8.19583 9.46653C7.46917 8.8406 7.29435 7.69098 7.78546 6.87098C8.09805 6.33247 8.66175 5.94062 9.28175 5.86136Z'
      fill='#2D6772'
    />
    <path
      d='M17.4193 8.33939C17.4482 8.06976 17.7289 7.88606 17.9889 7.92828C18.1882 7.95346 18.3134 8.12976 18.4364 8.26976V10.6964C18.3104 10.8335 18.183 11.0038 17.986 11.0305C17.7238 11.072 17.443 10.8801 17.4171 10.6097C17.3727 10.2483 17.4052 9.88234 17.3986 9.51864C17.4067 9.12605 17.3697 8.7305 17.4193 8.33939Z'
      fill='#2D6772'
    />
    <path
      d='M8.01634 11.0985C8.79338 10.9978 9.58078 11.0785 10.3623 11.0504C10.9119 11.0229 11.4778 11.1155 11.9511 11.4104C12.7341 11.8666 13.2482 12.7615 13.2171 13.6703C13.22 13.9637 12.9437 14.1829 12.6608 14.1563C10.6586 14.1607 8.65634 14.1518 6.65413 14.16C6.44524 14.1585 6.19487 14.1592 6.05709 13.974C5.88894 13.754 5.94672 13.4563 5.97857 13.2029C6.14154 12.1696 6.9919 11.2985 8.01634 11.0985Z'
      fill='#2D6772'
    />
    <path
      d='M17.411 12.5577C17.4207 12.297 17.6577 12.074 17.9192 12.0888C18.1451 12.0777 18.2962 12.2718 18.4369 12.4192V14.7651C18.3807 14.8814 18.3266 15.0044 18.2303 15.094C17.9866 15.3059 17.5429 15.197 17.4444 14.8829C17.3681 14.6081 17.4029 14.3177 17.397 14.0362C17.4118 13.5436 17.374 13.0496 17.411 12.5577Z'
      fill='#2D6772'
    />
    <defs>
      <path
        id='stroke0_26501_2269'
        d='M17.4874 3.9794C17.6311 3.75051 17.9666 3.68681 18.1918 3.82977C18.3155 3.91866 18.374 4.06606 18.4363 4.1994V6.47642C18.3489 6.61124 18.2622 6.76309 18.1103 6.8342C17.8711 6.93494 17.5563 6.82531 17.4555 6.58013C17.3881 6.40902 17.3992 6.22087 17.394 6.04087C17.4 5.54383 17.3985 5.04754 17.3948 4.55051C17.4015 4.3594 17.3866 4.15125 17.4874 3.9794Z'
      />
    </defs>
  </svg>
);

export default IcRegularCustomer;
